import { createSlice } from "@reduxjs/toolkit";

const appointmentRequestSlice = createSlice({
  name: "db4",
  initialState: {
    clientAppointmentRequests: [],
    pageSize: 10,
    displayArchiveOnly: false,
  },
  reducers: {
    setAppointmentRequests(state, action) {
      const { clientAppointmentRequests = [] } = action.payload;
      state.clientAppointmentRequests = clientAppointmentRequests;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setDisplayArchiveOnly(state, action) {
      state.displayArchiveOnly = action.payload;
    },
  },
});

export const { setAppointmentRequests, setPageSize, setDisplayArchiveOnly } = appointmentRequestSlice.actions;

export default appointmentRequestSlice.reducer;
